module.exports = __webpack_public_path__ + "static/media/fenqihudadongshan_web.3a8e72fe.png";